const CONNECTION_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'TypeError: cancelled',
    'The Internet connection appears to be offline',
    'The network connection was lost'
];

const hasMessage = (error: unknown): error is { message: string } =>
    error !== null && typeof error === 'object' && typeof (error as { message: string }).message === 'string';

/** Connection failed before reaching the server — safe to retry */
export const isTransientNetworkError = (error: unknown): boolean => {
    if (!hasMessage(error)) return false;
    return CONNECTION_ERROR_MESSAGES.some(msg => error.message.includes(msg));
};
